import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a5cdd1d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-body mt-3 d-flex flex-column justify-content-start align-content-start px-3" }
const _hoisted_2 = { class: "text-start mb-3" }
const _hoisted_3 = { class: "fs-4 fw-bold content-title" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("開啟大門")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("開啟Car教室")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("開啟Sunny教室")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("開啟儲藏室")
const _hoisted_8 = { class: "d-flex flex-column" }
const _hoisted_9 = { class: "col-12 text-start d-flex" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("大門")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("car教室")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Sunny教室")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("儲藏室")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("週一")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("週二")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("週三")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("週四")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("週五")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("週六")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("週日")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("清除")
const _hoisted_22 = /*#__PURE__*/_createTextVNode("批次匯入")
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-upload__text" }, [
  /*#__PURE__*/_createTextVNode("拖曳文件至此 或 "),
  /*#__PURE__*/_createElementVNode("em", null, "點擊上傳")
], -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip" }, "上傳檔案格式: *.csv", -1))
const _hoisted_25 = /*#__PURE__*/_createTextVNode("處理檔案")

import { onMounted, ref, reactive, computed, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import { useUserInfoStore } from "@/stores/UserInfoStore";
import API from '@/apis/TPSAPI';
import { FormInstance, FormRules, UploadProps, UploadUserFile, ElMessage, NotificationParams, ElNotification  } from 'element-plus';
import {formatDate, formatTime} from "@/plugins/dateUtils";

import DoorUserList from "@/components/DoorUserList.vue";
import DoorUserSettingList from "@/components/DoorUserSeetingList.vue";
import {M_IUsersOptions} from "@/models/M_IUsersOptions";
import {M_IsettingAccessRuleForm} from "@/models/M_IsettingAccessRuleForm";
import CreateStudentPermission from "@/models/M_CreateStudentPermission";
import {M_ICourseOptions} from "@/models/M_ICourseOptions";
import {M_ITeachersOptions} from "@/models/M_ITeachersOptions";



import axios from "axios";
import { M_IClassRoomOptions } from "@/models/M_IClassRoomOptions";

export default /*#__PURE__*/_defineComponent({
  __name: 'MusicAccessControl',
  setup(__props) {

const { t, locale } = useI18n();
const router = useRouter();
const userInfoStore = useUserInfoStore();
const usersOptions = ref<M_IUsersOptions[]>([]);
const teachersOptions = ref<M_ITeachersOptions[]>([]);
const courseList = ref<M_ICourseOptions[]>([]);
const doors = [1,2,3,4];
const days = [1,2,3,4,5,6,7];
const classRoomList = ref<M_IClassRoomOptions[]>([]);

const doorUserSettingListRef = ref(null);
const isShowUploadDialog = ref(false);


//#region UI Events
const settingForm = async () => {
  settingAccessTimeForm.value?.validate(async (valid) => {
    if (valid) {

      // 格式化日期为 YYYY-MM-DD
      ssetStudentPermission.datefrom = formatDate(new Date(settingAccessTimeFormData.datepicker[0]));
      ssetStudentPermission.dateto = formatDate(new Date(settingAccessTimeFormData.datepicker[1]));

      // 格式化时间为 HH:MM
      ssetStudentPermission.timefrom = formatTime(new Date(settingAccessTimeFormData.timepicker[0]));
      ssetStudentPermission.timeto = formatTime(new Date(settingAccessTimeFormData.timepicker[1]));

      ssetStudentPermission.userId = Number(settingAccessTimeFormData.userId);
      ssetStudentPermission.days = settingAccessTimeFormData.days;
      ssetStudentPermission.groupIds = settingAccessTimeFormData.groupIds;
      
      // 如果是租借教室(type=2)，不設定 courseId 和 teacherId
      if (settingAccessTimeFormData.type === '1') {
        ssetStudentPermission.courseId = Number(settingAccessTimeFormData.courseId);
        ssetStudentPermission.teacherId = Number(settingAccessTimeFormData.teacherId);
      } else {
        // 租借教室時，設為 undefined 讓後端忽略這些欄位
        ssetStudentPermission.courseId = undefined;
        ssetStudentPermission.teacherId = undefined;
      }
      
      ssetStudentPermission.type = Number(settingAccessTimeFormData.type);
      ssetStudentPermission.classroomId = settingAccessTimeFormData.classroomId
      ssetStudentPermission.courseMode = settingAccessTimeFormData.courseMode
      ssetStudentPermission.scheduleMode =settingAccessTimeFormData.scheduleMode

      console.log(ssetStudentPermission);

      try {
        // const settingResponse = await API.setPermission(settingAccessTimeFormData);

        // 更改為多時段
        const settingResponse = await API.setStudentPermission(ssetStudentPermission);
        
        // 根據需要處理 settingResponse
        console.log('Permission set successfully', settingResponse);
        console.log('Permission set successfully', settingResponse.data);

        let notifyParam: NotificationParams = {};
        if (settingResponse.data.result == 1) {
            notifyParam = {
            title: "成功",
            type: "success",
            message:`門禁設定成功`,
            duration: 1000,
          };
          clearForm();
          doorUserSettingListRef.value?.onFilterInputed();
        }
        if (settingResponse.data.result != 1) {
          clearForm();
          return;
        }
        ElNotification(notifyParam);

      } catch (error) {
        console.error('Failed to set permission', error);
      }

    } else {
      console.log('error submit!');
    }
  });
};

const clearForm = ()=>{
  settingAccessTimeForm.value?.resetFields();
  settingAccessTimeFormData.datepicker = '';
  settingAccessTimeFormData.timepicker = '';
};

const onUploadClicked = () => {
  isShowUploadDialog.value = true;
};

const handleTabClick = (tab) => {
  if (tab.name === 'doorUser') {
    doorUserSettingListRef.value?.onFilterInputed(); // 调用 DoorUserSettingList 中的方法
  }
}
//#endregion

//#region Hook functions
onMounted(() => {
  console.log('Component is mounted');
  getUsersOptions();
  getCourseOptions();
  getClassRoomsOptions();

});
//#endregion

//#region Private Functions
async function getUsersOptions() {
  try {
    const getUsersOptionsResult = await API.getUsersOptions();
    if (getUsersOptionsResult.data.result != 1) throw new Error(getUsersOptionsResult.data.msg);
    // usersOptions.value = getUsersOptionsResult.data.content;
    usersOptions.value = getUsersOptionsResult.data.content.filter(user => ![52, 54].includes(user.userId));
    
    const getTeachersOptionsResult = await API.getTeachersOptions();
    if (getTeachersOptionsResult.data.result != 1) throw new Error(getTeachersOptionsResult.data.msg);
    teachersOptions.value = getTeachersOptionsResult.data.content;

  } catch (error) {
    console.error(error);
  }
}

async function getCourseOptions () {
  try {
      const response = await API.getCourse();
      courseList.value = response.data.content
      console.log(courseList.value)
    } catch (error) {
      console.error('載入課程資料失敗:', error);
      // 可以在這裡加入錯誤處理，例如顯示提示訊息
    }
}

async function getClassRoomsOptions() {
  try {
    const response = await API.getClassrooms();
    classRoomList.value = response.data.content;

  } catch (error) {
    console.error('載入教室資料失敗:', error);
  }
}
//#endregion

//#region 建立表單ref與Validator
// 設定通行時間表單
const settingAccessTimeForm = ref<FormInstance>();
const settingAccessTimeFormData = reactive<M_IsettingAccessRuleForm>({
  userId: '',
  datepicker: '',
  timepicker: '',
  days: [],
  groupIds: [1],
  datefrom: '',
  dateto: '',
  timefrom:'',
  timeto: '',
  courseId: '',
  teacherId: '',
  type:'1',
  classroomId:'',
  courseMode:'',
  scheduleMode:''
})
const ssetStudentPermission = reactive<M_IsettingAccessRuleForm>({
  userId: 0,
  days: [],
  groupIds: [],
  datefrom: '',
  dateto: '',
  timefrom:'',
  timeto: '',
  courseId: 0,
  teacherId: 0,
  type: 1,
  classroomId:'',
  courseMode:'',
  scheduleMode:''
})
const rules  = reactive<FormRules>({
  userId: [{ required: true, message: () => t("validation_msg.username_is_required"), trigger: "blur" }],
  datepicker: [{ required: true, message: () => t("validation_msg.displayname_is_required"), trigger: "blur" }],
  timepicker: [{ required: true, message: () => t("validation_msg.displayname_is_required"), trigger: "blur" }],
  days: [{ required: true, message: () => t("validation_msg.displayname_is_required"), trigger: "blur" }],
  groupIds: [{ required: true, message: () => t("validation_msg.displayname_is_required"), trigger: "blur" }],
});


//#endregion

const callApi = () => {
  const requestOptions = {
      method: "POST",
      url: "http://127.0.0.1:1029/api/v1/Unlock/1",
      redirect: "follow"
  };

  axios(requestOptions)
  .then((response) => {
      console.log(response.data);
  })
  .catch((error) => {
      console.error(error);
  });
}

const callApiCar = () => {
  const requestOptions2 = {
      method: "POST",
      url: "http://127.0.0.1:1029/api/v1/Unlock/2",
      redirect: "follow"
  };

  axios(requestOptions2)
  .then((response) => {
      console.log(response.data);
  })
  .catch((error) => {
      console.error(error);
  });
}

const callApiSunny = () => {
  const requestOptions3 = {
      method: "POST",
      url: "http://127.0.0.1:1029/api/v1/Unlock/3",
      redirect: "follow"
  };

  axios(requestOptions3)
  .then((response) => {
      console.log(response.data);
  })
  .catch((error) => {
      console.error(error);
  });
}

const callApiStore = () => {
  const requestOptions4 = {
      method: "POST",
      url: "http://127.0.0.1:1029/api/v1/Unlock/4",
      redirect: "follow"
  };

  axios(requestOptions4)
  .then((response) => {
      console.log(response.data);
  })
  .catch((error) => {
      console.error(error);
  });
}

// #region 批次匯入功能
const fileList = ref<UploadUserFile[]>([])

const csvContent = ref<Array<CreateStudentPermission>>([]);

const beforeUpload = (file: File) => {
  const isCSV = file.type === 'text/csv';
  if (!isCSV) {
    ElMessage.error('上傳檔案格式不正確');
  }
  return isCSV;
};


const handleChange: UploadProps['onChange'] = (uploadFile, uploadFiles) => {
  // Add the new file entry to the fileList
  fileList.value.push({
    name: uploadFile.name,
    url: '' // Assuming there's no URL for this local file
  })
  
  // Keep only the last 3 entries in the fileList
  fileList.value = fileList.value.slice(-3)

  const reader = new FileReader();
  console.log(123)
  reader.onload = (e: ProgressEvent<FileReader>) => {
    if (e.target && e.target.result) {
      const content = e.target.result.toString();
      csvContent.value = csvToArray(content);
      console.log(JSON.stringify(csvContent.value, null, 2));
    }
  };
  if (uploadFile.raw) {
    reader.readAsText(uploadFile.raw);
  }
}

// 將 CSV 字串轉換為物件陣列
const csvToArray = (str: string, delimiter = ",") => {
  const headers = str.slice(0, str.indexOf("\n")).split(delimiter).map(header => header.trim());
  const rows = str.slice(str.indexOf("\n") + 1).split("\n").filter(row => row.trim() !== '');
  return rows.map(row => {
    const values = row.split(delimiter).map(value => value.trim());
    const obj = headers.reduce((object, header, index) => {
      object[header] = values[index];
      return object;
    }, {} as Record<string, any>);
    
    const parseArray = (str: string) => {
      return str ? str.split(',').map(value => {
        const num = Number(value.trim());
        return isNaN(num) ? null : num;
      }).filter(num => num !== null) : [];
    };

    // 使用更严格的解析方法
    const request: M_IsettingAccessRuleForm = {
      userId: parseInt(obj.userId),
      datefrom: obj.datefrom,
      dateto: obj.dateto,
      timefrom: obj.timefrom,
      timeto: obj.timeto,
      days: parseArray(obj.days),
      groupIds: parseArray(obj.groupIds)
      // datepicker: obj.datefrom,  // 假设 datepicker 为 datefrom 的值
      // timepicker: `${obj.timefrom} - ${obj.timeto}`  // 假设 timepicker 为 timefrom 和 timeto 的组合
    };
    
    return request;
  });
};

const onFileUploadClicked = async () => {
  for (const item of csvContent.value) {
    try {
      const response = await API.setStudentPermission(item);
      console.log(response.data);

      let notifyParam: NotificationParams = {};

      if (response.data.result != 1) {
          notifyParam = {
          title: "失敗",
          type: "error",
          message: `新增失敗：${item.userId} : ${response.data.msg}`,
          duration: 1000,
        };
      }

      if (response.data.result == 1) {
          notifyParam = {
          title: "成功",
          type: "success",
          message:`已新增使用者：${item.userId}`,
          duration: 1000,
        };
      }

      ElNotification(notifyParam);

    } catch (error) {
      console.error(error);
    }
  }

  // 清空 fileList
  fileList.value = [];

  isShowUploadDialog.value = false;
};
//#endregion


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_time_picker = _resolveComponent("el-time-picker")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_upload_filled = _resolveComponent("upload-filled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)("Access Control")), 1)
    ]),
    _createVNode(_component_el_tabs, {
      type: "border-card",
      onTabClick: handleTabClick
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, {
          label: _unref(t)('Open Door Button')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (callApi()))
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (callApiCar()))
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (callApiSunny()))
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (callApiStore()))
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_tab_pane, {
          label: _unref(t)('Access Control Settings')
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_el_form, {
                  class: "col-4",
                  inline: true,
                  "label-width": "100px",
                  ref_key: "settingAccessTimeForm",
                  ref: settingAccessTimeForm,
                  rules: rules,
                  model: settingAccessTimeFormData,
                  "label-position": "top",
                  style: {"margin-top":"15px","width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "姓名",
                      prop: "userId"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          filterable: "",
                          placeholder: "請選擇",
                          modelValue: settingAccessTimeFormData.userId,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((settingAccessTimeFormData.userId) = $event))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(usersOptions.value, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.userId,
                                label: item.displayName,
                                value: item.userId
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "門禁種類",
                      prop: "type"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          filterable: "",
                          placeholder: "請選擇",
                          modelValue: settingAccessTimeFormData.type,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((settingAccessTimeFormData.type) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "上課",
                              value: "1"
                            }),
                            _createVNode(_component_el_option, {
                              label: "租借教室",
                              value: "2"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _withDirectives(_createVNode(_component_el_form_item, {
                      label: "課程類別",
                      prop: "courseId"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          filterable: "",
                          placeholder: "請選擇",
                          modelValue: settingAccessTimeFormData.courseId,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((settingAccessTimeFormData.courseId) = $event))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(courseList.value, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.courseId,
                                label: item.courseName,
                                value: item.courseId
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, settingAccessTimeFormData.type === '1']
                    ]),
                    _createVNode(_component_el_form_item, {
                      label: "課程模式",
                      prop: "courseMode"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          filterable: "",
                          placeholder: "請選擇",
                          modelValue: settingAccessTimeFormData.courseMode,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((settingAccessTimeFormData.courseMode) = $event)),
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "現場",
                              value: "1"
                            }),
                            _createVNode(_component_el_option, {
                              label: "視訊",
                              value: "2"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _withDirectives(_createVNode(_component_el_form_item, {
                      label: "老師姓名",
                      prop: "teacherId"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          filterable: "",
                          placeholder: "請選擇",
                          modelValue: settingAccessTimeFormData.teacherId,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((settingAccessTimeFormData.teacherId) = $event))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(teachersOptions.value, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.teacherId,
                                label: item.teacherName,
                                value: item.teacherId
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, settingAccessTimeFormData.type === '1']
                    ]),
                    _createVNode(_component_el_form_item, {
                      label: "教室",
                      prop: "classroomId"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          filterable: "",
                          placeholder: "請選擇",
                          modelValue: settingAccessTimeFormData.classroomId,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((settingAccessTimeFormData.classroomId) = $event)),
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(classRoomList.value, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.classroomId,
                                label: item.classroomName,
                                value: item.classroomId?.toString()
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "門禁權限",
                      prop: "groupIds"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_checkbox_group, {
                          modelValue: settingAccessTimeFormData.groupIds,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((settingAccessTimeFormData.groupIds) = $event))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(doors, (item) => {
                              return _createVNode(_component_el_checkbox, {
                                key: item,
                                label: item,
                                value: item
                              }, {
                                default: _withCtx(() => [
                                  (item === 1)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _hoisted_10
                                      ], 64))
                                    : (item === 2)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _hoisted_11
                                        ], 64))
                                      : (item === 3)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                            _hoisted_12
                                          ], 64))
                                        : (item === 4)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                              _hoisted_13
                                            ], 64))
                                          : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1032, ["label", "value"])
                            }), 64))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "週期模式",
                      prop: "scheduleMode"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          filterable: "",
                          placeholder: "請選擇",
                          modelValue: settingAccessTimeFormData.scheduleMode,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((settingAccessTimeFormData.scheduleMode) = $event)),
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "每週",
                              value: "1"
                            }),
                            _createVNode(_component_el_option, {
                              label: "每兩週",
                              value: "2"
                            }),
                            _createVNode(_component_el_option, {
                              label: "單次",
                              value: "3"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "通行日期",
                      prop: "datepicker"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          type: "daterange",
                          "range-separator": "至",
                          "start-placeholder": "開始日期",
                          "end-placeholder": "結束日期",
                          modelValue: settingAccessTimeFormData.datepicker,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((settingAccessTimeFormData.datepicker) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "通行時間",
                      prop: "timepicker"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_time_picker, {
                          "is-range": "",
                          "range-separator": "至",
                          "start-placeholder": "開始時間",
                          "end-placeholder": "結束時間",
                          modelValue: settingAccessTimeFormData.timepicker,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((settingAccessTimeFormData.timepicker) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "週期",
                      prop: "days"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_checkbox_group, {
                          modelValue: settingAccessTimeFormData.days,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((settingAccessTimeFormData.days) = $event))
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(days, (item) => {
                              return _createVNode(_component_el_checkbox, {
                                key: item,
                                label: item,
                                value: item
                              }, {
                                default: _withCtx(() => [
                                  (item === 1)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _hoisted_14
                                      ], 64))
                                    : (item === 2)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _hoisted_15
                                        ], 64))
                                      : (item === 3)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                            _hoisted_16
                                          ], 64))
                                        : (item === 4)
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                              _hoisted_17
                                            ], 64))
                                          : (item === 5)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                                _hoisted_18
                                              ], 64))
                                            : (item === 6)
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                                  _hoisted_19
                                                ], 64))
                                              : (item === 7)
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                                    _hoisted_20
                                                  ], 64))
                                                : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1032, ["label", "value"])
                            }), 64))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { style: {"margin-top":"auto"} }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: _cache[15] || (_cache[15] = ($event: any) => (settingForm()))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)("Settings")), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: _cache[16] || (_cache[16] = ($event: any) => (clearForm()))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_21
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_button, {
                          type: "primary",
                          onClick: _cache[17] || (_cache[17] = ($event: any) => (onUploadClicked()))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_22
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["rules", "model"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_tab_pane, {
          label: _unref(t)('User Access Data'),
          name: "doorUser"
        }, {
          default: _withCtx(() => [
            _createVNode(DoorUserSettingList, {
              ref_key: "doorUserSettingListRef",
              ref: doorUserSettingListRef,
              doorId: 1
            }, null, 512)
          ]),
          _: 1
        }, 8, ["label"]),
        false
          ? (_openBlock(), _createBlock(_component_el_tab_pane, {
              key: 0,
              label: "大門"
            }, {
              default: _withCtx(() => [
                _createVNode(DoorUserList, { doorId: 1 })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        false
          ? (_openBlock(), _createBlock(_component_el_tab_pane, {
              key: 1,
              label: "Car教室"
            }, {
              default: _withCtx(() => [
                _createVNode(DoorUserList, { doorId: 2 })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        false
          ? (_openBlock(), _createBlock(_component_el_tab_pane, {
              key: 2,
              label: "Sunny教室"
            }, {
              default: _withCtx(() => [
                _createVNode(DoorUserList, { doorId: 3 })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        false
          ? (_openBlock(), _createBlock(_component_el_tab_pane, {
              key: 3,
              label: "儲藏室"
            }, {
              default: _withCtx(() => [
                _createVNode(DoorUserList, { doorId: 4 })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      width: "500px",
      title: "批次匯入",
      modelValue: isShowUploadDialog.value,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((isShowUploadDialog).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_upload, {
          class: "upload-demo",
          drag: "",
          "before-upload": beforeUpload,
          action: "https://run.mocky.io/v3/9d059bf9-4660-45f2-925d-ce80ad6c4d15",
          "on-change": handleChange,
          "file-list": fileList.value,
          multiple: ""
        }, {
          tip: _withCtx(() => [
            _hoisted_24
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_component_upload_filled)
              ]),
              _: 1
            }),
            _hoisted_23
          ]),
          _: 1
        }, 8, ["file-list"]),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: onFileUploadClicked
        }, {
          default: _withCtx(() => [
            _hoisted_25
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})